export const ActionTypes = {
  LOADING: "GET_ROLES_LOADING",
  ERROR: "GET_ROLES_ERROR",
  SUCCESS: "GET_ROLES_SUCCESS",

  CREATE_CUSTOM_SUCCESS: "CREATE_CUSTOM_ROLE_SUCCESS",
  DELETE_CUSTOM_SUCCESS: "DELETE_CUSTOM_ROLE_SUCCESS",
};
